import { AccordionItem } from '@library/components/sections/Accordion';
import { Button } from '@library/components/buttons';
import type { FormattedChannel } from '@library/types/alerts';

export interface ChannelButtonProps {
  channel: FormattedChannel;
  selectedChannelId: number;
  handleChannelChange: (channel: FormattedChannel) => void;
}

export const ChannelButton = ({
  channel,
  selectedChannelId,
  handleChannelChange
}: ChannelButtonProps) => {
  const { id: channelId, displayName } = channel;

  const isCurrentChannel = channelId === selectedChannelId;

  const buttonClass = isCurrentChannel
    ? 'bg-stankonia-300 rounded-lg p-2'
    : 'p-2';

  const handleClick = () => {
    handleChannelChange(channel);
  };

  return (
    <AccordionItem value={`channel ${channelId}`}>
      <Button
        className={`w-11/12 pl-7 text-left ${buttonClass}`}
        onClick={handleClick}
      >
        <p
          className={
            channel.isChannelUnread || isCurrentChannel
              ? 'text-soClean-100'
              : 'text-soClean-170'
          }
        >{`#${displayName}`}</p>
      </Button>
    </AccordionItem>
  );
};
